let obj = {
    locales: {},
    tags:[],
    media:""
}
export default obj;